<template>
  <div class="home-page">
    <div class="page1">
      <span>{{ $t("module.taskD.title1") }} </span>
      <img src="@/assets/image/module/roow-right.png" />
      {{ info.number }}
    </div>

    <div class="content-box">
      <div class="left">
        <div class="left-top">
          <div class="lene-box">
            <div class="text-box">{{ info.title }}</div>
            <div class="text-title">
              {{ info.number }}<span>({{ info.platform }})</span>
            </div>
          </div>
          <div class="lene-box2">
            <div class="text-box">{{ $t("module.taskD.title4") }}</div>
            <div class="text-title">
              {{ info.minPoints }}~{{ info.maxPoints
              }}<span>{{ $t("module.taskD.title5") }}</span>
            </div>
          </div>
          <div class="lene-box3">
            <div class="text-box">{{ $t("module.taskD.title6") }}</div>
            <div class="text-title">
              {{ info.realtime === 1 ? $t("common.taskDetails.instantReward") : $t("common.taskDetails.unifiedReward") }}
            </div>
          </div>
          <div class="lene-box3">
            <div class="text-box">{{ $t("module.taskD.title8") }}</div>
            <div class="text-title">
              {{ $t("module.taskD.title9") }}<span>{{ info.loi }}</span
              >{{ $t("module.taskD.title10") }}
            </div>
          </div>
          <div class="lene-box3">
            <div class="text-box">{{ $t("module.taskD.title16") }}</div>
            <div class="text-title">
              <span>{{ info.ir }}%</span>
            </div>
          </div>
          <div
            :class="`${flag ? 'btn btn-active' : 'btn'}`"
            @click="submit(info)"
          >
            {{ $t("module.taskD.title13") }}
          </div>
        </div>
        <div class="left-bottom">
          <div class="tips">{{ $t("module.taskD.title11") }}:</div>
          <p v-html="info.welcomeContent"></p>
        </div>
      </div>
      <div class="right">
        <div class="img-box">
          <div class="title">{{ $t("module.taskD.title14") }}</div>
          <div :class="['p-box', { 'p-box-en': $i18n.locale === 'en' }]">
            <p v-html="$t('module.taskD.title15')"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="m-page1">
      <div class="m-title">
        <img src="@/assets/image/module/roow-right.png" />
        <span> {{ info.number }}</span>
      </div>
      <div class="lene-box">
        <div class="text-box">{{ info.number }}</div>
        <div class="text-title">
          <span>({{ info.platform }})</span>
        </div>
      </div>
      <div class="lene-title">{{ info.title }}</div>
      <div class="lene-box2">
        <div class="text-box">{{ $t("module.taskD.title4") }}</div>
        <div class="text-title">
          {{ info.minPoints }}~{{ info.maxPoints
          }}<span>{{ $t("module.taskD.title5") }}</span>
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title6") }}</div>
        <div class="text-title">
          {{ info.realtime === 1 ? $t("common.taskDetails.instantReward") : $t("common.taskDetails.unifiedReward") }}
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title8") }}</div>
        <div class="text-title">
          {{ $t("module.taskD.title9") }}<span>{{ info.loi }}</span
          >{{ $t("module.taskD.title10") }}
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title16") }}</div>
        <div class="text-title">
          <span>{{ info.ir }}%</span>
        </div>
      </div>

      <div class="tips-box">
        <div class="title">{{ $t("module.taskD.title14") }}</div>
        <div :class="['p-box', { 'p-box-en': $i18n.locale === 'en' }]">
          <p v-html="info.welcomeContent"></p>
        </div>
      </div>
      <div class="btn-box">
        <div
          :class="`${flag ? 'btn btn-active' : 'btn'}`"
          @click="submit(info)"
        >
          {{ $t("module.taskD.title13") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSurveysItem, getsurveyTake } from "@/api/user";
import Fingerprint from "@/utils/fingerprint";
export default {
  data() {
    return {
      id: 0,
      info: {
        id: 0,
        encryptId: null,
        number: null,
        title: null,
        minPoints: 0,
        maxPoints: 0,
        extraPoints: 0,
        realtime: 0,
        sticky: true,
        startDate: null,
        endDate: null,
        loi: 0,
        ir: 0,
        platformType: 0,
        platform: null,
        thumbImage: null,
        surveyLink: null,
        welcomeContent: null,
        endContent: null,
        dateline: null,
        commercial: true,
        allowedHide: true,
        shareable: true,
        package: null,
        webId: null,
      },
      userInfo: {},
      flag: false,
    };
  },
  methods: {
    submit(data) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      getsurveyTake({
        encryptId: data.encryptId,
        webId: "aidajuan",
        anonymousId: "",
        uid: this.userInfo.id,
        gender: 0,
        birthday: "2026-05-20T01:16:12.237Z",
        provinceId: 0,
        cityId: 0,
        districtId: 0,
        fingerprintCode: new Fingerprint().get(),
        phoneCode: "",
        personalIncome: "",
        familyIncome: "",
        marriageId: 0,
        educationId: 0,
        extHintQuestion1Answer: "",
      }).then((res) => {
        this.flag = false;
        if (res.code === 200) {
          window.open(res.data, "_blank");
        }
      });
    },
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    localStorage.getItem("u");
    getSurveysItem({ id: this.id }).then((res) => {
      if (res.code === 200) {
        this.info = {
          id: res.data.id,
          encryptId: res.data.encryptId,
          number: res.data.number,
          title: res.data.title,
          minPoints: res.data.minPoints,
          maxPoints: res.data.maxPoints,
          extraPoints: res.data.extraPoints,
          realtime: res.data.realtime,
          sticky: res.data.sticky,
          startDate: res.data.startDate,
          endDate: res.data.endDate,
          loi: res.data.LOI,
          ir: res.data.IR,
          platformType: res.data.platformType,
          platform: res.data.platform,
          thumbImage: res.data.thumbImage,
          surveyLink: res.data.surveyLink,
          welcomeContent: res.data.welcomeContent,
          endContent: res.data.endContent,
          dateline: res.data.dateline,
          commercial: res.data.commercial,
          allowedHide: res.data.allowedHide,
          shareable: res.data.shareable,
          package: res.data.package,
          webId: res.data.webId,
        };
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  padding: 0 140px;
  color: #fefeff;
  box-sizing: border-box;
  .page1 {
    width: 100%;
    height: 62px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-top: 16px;
    box-sizing: border-box;
    padding-left: 30px;
    display: flex;
    align-items: center;
    color: #474f66;
    font-size: 16px;
    img {
      margin: 0 9px;
      width: 22px;
      height: 22px;
    }
  }

  .content-box {
    display: flex;
    margin-top: 16px;
    margin-bottom: 120px;
    .left {
      width: 100%;
      display: flex;
      flex-direction: column;
      .left-top {
        width: 100%;
        min-height: 262px;
        background: #fefeff;
        border-radius: 8px;
        margin-bottom: 16px;
        color: #333333;
        position: relative;
        .lene-box {
          display: flex;
          margin-left: 30px;
          margin-top: 30px;
          font-weight: bolder;
          .text-box {
            min-width: 120px;
            font-size: 16px;
            margin-right: 10px;
          }
          .text-title {
            font-size: 18px;
            span {
              font-size: 14px;
              color: #999;
              font-weight: normal;
            }
          }
        }
        .lene-box2 {
          margin-top: 44px;
          margin-left: 30px;
          display: flex;
          .text-box {
            width: 120px;
            font-size: 14px;
          }
          .text-title {
            font-size: 18px;
            color: #8948ff;
            font-weight: bolder;
            span {
              font-size: 14px;
              color: #8948ff;
              font-weight: normal;
            }
          }
        }
        .lene-box3 {
          margin-top: 20px;
          margin-left: 30px;
          display: flex;
          .text-box {
            width: 120px;
            font-size: 14px;
          }
          .text-title {
            font-size: 14px;
            span {
              font-size: 18px;
              font-weight: bolder;
              color: #8948ff;
            }
          }
        }
        .btn {
          position: absolute;
          width: 104px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
          background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
          box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
          border-radius: 16px 16px 16px 16px;
          right: 80px;
          top: 30px;
        }
        .btn-active {
          opacity: 0.7;
        }
      }
      .left-bottom {
        width: 100%;
        min-height: 182px;
        background: #fefeff;
        border-radius: 8px;
        color: #333333;
        padding: 30px;
        box-sizing: border-box;
        .tips {
          font-size: 16px;
          font-weight: bolder;
          margin-bottom: 16px;
        }
        p {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
    .right {
      width: 372px;
      margin-left: 16px;
      flex-shrink: 0;
      background-color: #fff;
      border-radius: 8px;
      padding: 30px 22px 0 18px;
      box-sizing: border-box;
      .img-box {
        width: 100%;
        height: 172px;
        background-image: url("../assets/image/module/bg10.png");
        background-size: cover;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        .title {
          width: 116px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          color: #fff;
          font-size: 14px;
        }
        .p-box {
          color: #8948ff;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          font-size: 14px;
          line-height: 24px;
          margin-top: 5px;
        }
        .p-box-en {
          line-height: 19px;
        }
      }
    }
  }
  .m-page1 {
    display: none;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 20px;
    color: #333333;
    .m-title {
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      color: #333333;
      img {
        width: 22px;
        height: 22px;
        transform: rotate(180deg);
        flex-shrink: 0;
      }
      span {
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: bolder;
      }
    }
    .lene-box {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      margin-bottom: 7px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 14px;
        color: #999999;
        font-weight: bolder;
      }
    }
    .lene-title {
      font-size: 14px;
      font-weight: bolder;
    }
    .lene-box2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 27px;
      margin-bottom: 15px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 18px;
        color: #8948ff;
        font-weight: bolder;
        span {
          font-weight: normal;
          font-size: 16px;
          margin-left: 5px;
        }
      }
    }
    .lene-box3 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 14px;
        span {
          font-size: 18px;
          font-weight: bolder;
          color: #8948ff;
        }
      }
    }
    .tips-box {
      margin-top: 30px;
      background-color: #f9f5ff;
      padding: 14px;
      box-sizing: border-box;
      line-height: 24px;
      .title {
        font-weight: bolder;
        margin-bottom: 14px;
      }
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
      padding: 48px 0 30px 0;
      align-items: center;
      .btn {
        width: 104px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
        box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
        border-radius: 16px 16px 16px 16px;
      }
      .btn-active {
        opacity: 0.7;
      }
      .title {
        color: #232323;
        font-size: 14px;
        margin-right: 24px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1300px) {
  .home-page {
    padding: 0 70px;
  }
}
/* 媒体查询 */
@media only screen and (max-width: 1200px) {
  .home-page {
    padding: 0 30px;

    .content-box {
      .left {
        .left-top {
          .btn {
            right: 30px;
            top: 55px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .home-page {
    padding: 0 15px;
    .page1 {
      display: none;
    }
    .content-box {
      display: none;
    }
    .m-page1 {
      display: block;
    }
  }
}
</style>